// extracted by mini-css-extract-plugin
module.exports = {"container":"Donuts_container__tgoFw","Main":"Donuts_Main__3HReB","Caret":"Donuts_Caret__1iRS8","ChartWrapper":"Donuts_ChartWrapper__xSSAp"};